import { supabase } from "@/lib/supabase/supabaseClient";
import { getUrl } from "@/lib/supabase/utils";

export const forgotPassword = async (email: string) => {
    return await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: getUrl(),
    });
}